import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { POST, GET } from "../../../utils/Methods";
import { APIS } from "../../../utils/APIS";
import { IDS } from "../../../utils/IDS";

//  Send Email OTP
export const SendEmailOtp = createAsyncThunk(
  "register/sendEmailOtp",
  async (data, { rejectWithValue }) => {
    try {
      console.log("Sending Email OTP:", data);
      const res = await POST(APIS.Register.SEND_EMAIL_OTP, data);
      console.log("Email OTP Response:", res);
      return res;
    } catch (error) {
      console.error("Email OTP API error:", error);
      return rejectWithValue(error?.response?.data || error.message);
    }
  }
);

//  Verify Email OTP
export const VerifyEmailOtp = createAsyncThunk(
  "register/verifyEmailOtp",
  async (data, { rejectWithValue }) => {
    try {
      console.log("Verifying Email OTP:", data);
      const res = await POST(APIS.Register.VERIFY_EMAIL_OTP, data);
      console.log("Verify Email OTP Response:", res);
      if (res?.success) {
        return res;
      }
      return rejectWithValue(res);
    } catch (error) {
      console.error("Verify Email OTP API error:", error);
      return rejectWithValue(error?.response?.data || error.message);
    }
  }
);

//  Send Phone OTP
export const SendPhoneOtp = createAsyncThunk(
  "register/sendPhoneOtp",
  async (data, { rejectWithValue }) => {
    try {
      console.log("Sending Phone OTP:", data);
      const res = await POST(APIS.Register.SEND_PHONE_OTP, data);
      console.log("Phone OTP Response:", res);
      return res;
    } catch (error) {
      console.error("Phone OTP API error:", error);
      return rejectWithValue(error?.response?.data || error.message);
    }
  }
);

//  Verify Phone OTP
export const VerifyPhoneOtp = createAsyncThunk(
  "register/verifyPhoneOtp",
  async (data, { rejectWithValue }) => {
    try {
      console.log("Verifying Phone OTP:", data);
      const res = await POST(APIS.Register.VERIFY_PHONE_OTP, data);
      console.log("Verify Phone OTP Response:", res);
      if (res?.success) {
        return res;
      }
      return rejectWithValue(res);
    } catch (error) {
      console.error("Verify Phone OTP API error:", error);
      return rejectWithValue(error?.response?.data || error.message);
    }
  }
);

//  Final Registration (After Both OTPs)
export const SubmitRegistration = createAsyncThunk(
  "register/submitRegistration",
  async (data, { rejectWithValue }) => {
    try {
      console.log("Submitting Registration Data:");
for (let pair of data.entries()) {
  console.log(pair[0] + ": " + pair[1]);
}

      const res = await POST(APIS.Register.SUBMIT_FORM, data);


      if (res?.success) {
        return res;
      }
      return rejectWithValue(res);
    } catch (error) {
      console.error("Submit Registration API error:", error);
      return rejectWithValue(error?.response?.data || error.message);
    }
  }
);




//  Slice
export const RegisterSlice = createSlice({
  name: "register",
  initialState: {
    // Email OTP
    emailOtpStatus: IDS.SLICESTATUS.Idle,
    emailOtpData: null,
    emailOtpError: null,

    verifyEmailOtpStatus: IDS.SLICESTATUS.Idle,
    verifyEmailOtpData: null,
    verifyEmailOtpError: null,

    // Phone OTP
    phoneOtpStatus: IDS.SLICESTATUS.Idle,
    phoneOtpData: null,
    phoneOtpError: null,

    verifyPhoneOtpStatus: IDS.SLICESTATUS.Idle,
    verifyPhoneOtpData: null,
    verifyPhoneOtpError: null,

    // Final Registration
    submitStatus: IDS.SLICESTATUS.Idle,
    submitData: null,
    submitError: null,

    // Personal Details
    personalDetails: {
      email: "",
      mobile_number: "",
      password: "",
      address: "",
      city: "",
      state: "",
      pincode: "",
      emailVerified: false,
      phoneVerified: false,
    },
  },
  reducers: {
    // Update local state when form fields change
    setPersonalDetails: (state, action) => {
      state.personalDetails = { ...state.personalDetails, ...action.payload };
    },
    resetRegistration: (state) => {
      state.submitStatus = IDS.SLICESTATUS.Idle;
      state.submitData = null;
      state.submitError = null;
      state.personalDetails = {
        email: "",
        mobile_number: "",
        password: "",
        address: "",
        city: "",
        state: "",
        pincode: "",
        emailVerified: false,
        phoneVerified: false,
      };
    },
  },
  extraReducers: (builder) => {
    builder
      //  Send Email OTP
      .addCase(SendEmailOtp.pending, (state) => {
        state.emailOtpStatus = IDS.SLICESTATUS.Loading;
      })
      .addCase(SendEmailOtp.fulfilled, (state, action) => {
        state.emailOtpStatus = IDS.SLICESTATUS.Succeeded;
        state.emailOtpData = action.payload?.data;
      })
      .addCase(SendEmailOtp.rejected, (state, action) => {
        state.emailOtpStatus = IDS.SLICESTATUS.Failed;
        state.emailOtpError = action.payload;
      })

      //  Verify Email OTP
      .addCase(VerifyEmailOtp.pending, (state) => {
        state.verifyEmailOtpStatus = IDS.SLICESTATUS.Loading;
      })
      .addCase(VerifyEmailOtp.fulfilled, (state, action) => {
        state.verifyEmailOtpStatus = IDS.SLICESTATUS.Succeeded;
        state.verifyEmailOtpData = action.payload?.data;
        state.personalDetails.emailVerified = true;
      })
      .addCase(VerifyEmailOtp.rejected, (state, action) => {
        state.verifyEmailOtpStatus = IDS.SLICESTATUS.Failed;
        state.verifyEmailOtpError = action.payload;
      })

      //  Send Phone OTP
      .addCase(SendPhoneOtp.pending, (state) => {
        state.phoneOtpStatus = IDS.SLICESTATUS.Loading;
      })
      .addCase(SendPhoneOtp.fulfilled, (state, action) => {
        state.phoneOtpStatus = IDS.SLICESTATUS.Succeeded;
        state.phoneOtpData = action.payload?.data;
      })
      .addCase(SendPhoneOtp.rejected, (state, action) => {
        state.phoneOtpStatus = IDS.SLICESTATUS.Failed;
        state.phoneOtpError = action.payload;
      })

      //  Verify Phone OTP
      .addCase(VerifyPhoneOtp.pending, (state) => {
        state.verifyPhoneOtpStatus = IDS.SLICESTATUS.Loading;
      })
      .addCase(VerifyPhoneOtp.fulfilled, (state, action) => {
        state.verifyPhoneOtpStatus = IDS.SLICESTATUS.Succeeded;
        state.verifyPhoneOtpData = action.payload?.data;
        state.personalDetails.phoneVerified = true;
      })
      .addCase(VerifyPhoneOtp.rejected, (state, action) => {
        state.verifyPhoneOtpStatus = IDS.SLICESTATUS.Failed;
        state.verifyPhoneOtpError = action.payload;
      })

      //  Submit Registration
      .addCase(SubmitRegistration.pending, (state) => {
        state.submitStatus = IDS.SLICESTATUS.Loading;
      })
      .addCase(SubmitRegistration.fulfilled, (state, action) => {
        state.submitStatus = IDS.SLICESTATUS.Succeeded;
        state.submitData = action.payload?.data;
      })
      .addCase(SubmitRegistration.rejected, (state, action) => {
        state.submitStatus = IDS.SLICESTATUS.Failed;
        state.submitError = action.payload;
      })

      


  },
});

export const { setPersonalDetails, resetRegistration } = RegisterSlice.actions;
export default RegisterSlice.reducer;
